'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var STATUS = exports.STATUS = {
  WAITING: -1,
  TIMEOUT: 0,
  ACTIVE: 100,
  SUCCESS: 200,
  FAIL: 400,
  NOT_FOUND: 404
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/constants/status.js
// module id = 331
// module chunks = 0